import Vue from 'vue'
import Vuex from 'vuex'
// import API from '@/request.js'
import createPersistedState from 'vuex-persistedstate'
// import Analytics from '@/utils/analytics'

Vue.use(Vuex)

const persistedState = ['analytics']

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            key: 'project.store.v1.0',
            paths: persistedState
        })
    ],
    state: {
        links: {
            pikabu: 'https://pikabu.ru/',
            pik: 'https://pikabu.ru/story/botromlada_so_uozhonnzhetsam_sdey_neel_sedzhe_4510025'
        }
    },
    actions: {},
    mutations: {}
})
